import androidx.compose.runtime.*
import kotlinx.coroutines.promise
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.placeholder

@Composable
fun AuthScreen(onLoginSuccess: () -> Unit) {
    var email by remember { mutableStateOf("") }
    var password by remember { mutableStateOf("") }
    var isLoading by remember { mutableStateOf(false) }
    var errorMsg by remember { mutableStateOf("") }

    // Центрирование контейнера
    Div({
        style {
            display(DisplayStyle.Flex)
            justifyContent(JustifyContent.Center)
            alignItems(AlignItems.Center)
            height(100.vh)
            backgroundColor(Color("#f0f2f5"))
        }
    }) {
        // Белая карточка
        Div({
            style {
                backgroundColor(Color.white)
                padding(40.px)
                borderRadius(12.px)
                property("box-shadow", "0 4px 15px rgba(0,0,0,0.1)")
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                width(300.px)
                property("gap", "15px")
            }
        }) {
            H2({ style { textAlign("center"); marginBottom(20.px) } }) { Text("Bienvenido a SIELE") }

            // Поля ввода
            Input(InputType.Email) {
                placeholder("Email")
                value(email)
                onInput { email = it.value }
                style { padding(10.px); borderRadius(6.px); border(1.px, LineStyle.Solid, Color("#ccc")) }
            }

            Input(InputType.Password) {
                placeholder("Contraseña")
                value(password)
                onInput { password = it.value }
                style { padding(10.px); borderRadius(6.px); border(1.px, LineStyle.Solid, Color("#ccc")) }
            }

            if (errorMsg.isNotEmpty()) {
                Span({ style { color(Color.red); fontSize(0.8.cssRem) } }) { Text(errorMsg) }
            }

            // Кнопка Вход
            Button({
                style { padding(12.px); backgroundColor(Color("#3498db")); color(Color.white); border(0.px); borderRadius(6.px); cursor("pointer") }
                onClick {
                    isLoading = true
                    errorMsg = ""
                    kotlinx.coroutines.GlobalScope.launch {
                        val success = DataRepository.login(email, password)
                        isLoading = false
                        if (success) onLoginSuccess() else errorMsg = "Error de inicio de sesión"
                    }
                }
            }) { Text(if (isLoading) "Cargando..." else "Iniciar Sesión") }

            // Кнопка Регистрация
            Button({
                style { padding(12.px); backgroundColor(Color("#2ecc71")); color(Color.white); border(0.px); borderRadius(6.px); cursor("pointer") }
                onClick {
                    isLoading = true
                    errorMsg = ""
                    kotlinx.coroutines.GlobalScope.launch {
                        val success = DataRepository.register(email, password)
                        isLoading = false
                        if (success) onLoginSuccess() else errorMsg = "Error al registrarse"
                    }
                }
            }) { Text("Registrarse") }
        }
    }
}

// Вспомогательная функция для запуска корутин из onClick (т.к. onClick не suspend)
fun kotlinx.coroutines.CoroutineScope.launch(block: suspend () -> Unit) {
    kotlinx.coroutines.GlobalScope.promise { block() }
}